export enum ApplicationHistoryActionType {
  GetApplicationHistory = 'applicationHistory/getApplicationHistory',
  ChangeSortingType = 'applicationHistory/changeSortingType',
  ChangeSelectedMembers = 'applicationHistory/changeSelectedMembers',
  ChangeFilterType = 'applicationHistory/changeFilterType',
  ChangeSearchValue = 'applicationHistory/changeSearchValue',
  ResetState = 'applicationHistory/ResetState',
}
